import {default as EventEmitter} from 'events';
import {default as Symbol} from 'es6-symbol';
import {default as Promise} from 'es6-promise';
import {default as debugModule} from 'util/debug.js';


const debug = debugModule(__filename);
const _singleton = Symbol();


class Handler extends EventEmitter {

    constructor(singletonToken) {
        if (_singleton !== singletonToken)
            throw new Error('Cannot instantiate directly.');

        super();
        this.apps = {};
    }

    static get instance() {
        if(!this[_singleton])
            this[_singleton] = new Handler(_singleton);

        return this[_singleton];
    }

    addApp(appName, appInstance) {
        debug('`addApp`', { appName, appInstance });
        this.apps[appName] = appInstance;
        this.emit(`${appName}_registered`);
    }

    removeApp(appName) {
        if(this.apps[appName]) {
            if(typeof this.apps[appName].destroy === 'function')
                this.apps[appName].destroy();

            delete this.apps[appName];
            return true;
        }
        return false;
    }

    refreshCommentCounters(callback) {
        if(this.apps.CommentCount)
            this.apps.CommentCount.refresh(callback);
    }

    ready(appName) {
        const app = this.apps[appName];
        const promise = new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            if(!app) {
                this.on(`${appName}_registered`, () => {
                    this.apps[appName].ready().then(resolve);
                });
            } else {
                app.ready().then(resolve);
            }
        });
        return promise;
    }

}


export default Handler.instance;


// WEBPACK FOOTER //
// ./src/util/handler.js